import { PhotoSeriesSearchOptions } from "constant/photo_series/photo_series.constant";
import { axiosCitajteo } from "../../axios/citajteo_axios";
import { DlUnit } from "model/dl_unit/DlUnit";
import { PhotoSeries } from "model/photo_series/PhotoSeries";

export const photoSeriesGet = async (
  id: string,
  searchBy: string = "id"
): Promise<any> => {
  let result: PhotoSeries | null = null;
  let response: any;
  try {
    response = await axiosCitajteo.get(
      `photo-series/${id}?searchBy=${searchBy}`
    );
  } catch (error) {}
  if (response && response.status === 200) {
    result = new PhotoSeries(response.data);
  }

  return result;
};

export type PhotoSeriesSearchParams = Partial<
  Record<PhotoSeriesSearchOptions, number | string>
>;

const photoSeriesResponseFormat = (series: any): PhotoSeries => {
  const result = new PhotoSeries(series);

  return result;
};

export const photoSeriesSearch = async (
  searchParams?: PhotoSeriesSearchParams
): Promise<any> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosCitajteo.post(
      `photo-series/search`,
      searchParams ?? {}
    );
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
    result.items = result.items.map((item: any) =>
      photoSeriesResponseFormat(item)
    );
  }

  return result;
};
